import __request__ from "routing/request";
export function queryStringUsed(queryStringRequest, requestOptions) {
  return __request__("POST", "/search/query_strings", queryStringRequest, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
